const CONSULTANT_PHONE_DIGITS = "48579779123";

export const CONSULTANT_PHONE_HREF = `tel:+${CONSULTANT_PHONE_DIGITS}`;
export const CONSULTANT_PHONE_DISPLAY = "+48 579 779 123";
export const CONSULTANT_PHONE_NATIONAL = `48 ${CONSULTANT_PHONE_DIGITS.slice(2)}`;
const CONSULTANT_PHONE_DIGITS = "48579779123";

export const CONSULTANT_PHONE_HREF = `tel:+${CONSULTANT_PHONE_DIGITS}`;
export const CONSULTANT_PHONE_DISPLAY = "+48 579 779 123";
export const CONSULTANT_PHONE_NATIONAL = `48 ${CONSULTANT_PHONE_DIGITS.slice(2)}`;
